import { extendObservable } from 'mobx';
import uuid from 'node-uuid';
import { snakeCase, camelCase } from '@ridi/object-case-converter';
import FeedbackComment from '../models/FeedbackComment';
import axios from '../../../libs/axios_csrf';
import FeedbackParticipant from '../models/FeedbackParticipant';

export default class FeedbackCommentsStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      feedbackComments: [],
    });
  }

  get attachmentsStore() {
    return this.rootStore.attachmentsStore;
  }

  addFeedbackComment(feedbackComment) {
    this.feedbackComments.push(feedbackComment);
  }

  loadFromJsonArray(array, feedbackChain) {
    const result = [];
    array.forEach((el) => {
      const feedbackComment = FeedbackComment.deserialize(el, feedbackChain, this);
      this.feedbackComments.push(feedbackComment);
      result.push(feedbackComment);
    });
    return result;
  }

  buildFeedbackComment(feedbackChain) {
    const feedbackComment = new FeedbackComment(this, '', feedbackChain, false);
    feedbackComment.creator = this.rootStore.user;
    return feedbackComment;
  }

  destroy(feedbackComment) {
    this.destroyBackend(feedbackComment);
    this.feedbackComments.remove(feedbackComment);
    feedbackComment.dispose();
  }


  destroyCommentFrontend(comment) {
    const chain = this.getFeedbackById(comment.feedbackChainId);
    chain.comments.splice(chain.comments.findIndex((e) => { e.id == comment.id; }), 1);
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  createBackend(feedbackComment) {
    axios.post('/feedback_comments.json', {
      feedback_comment: snakeCase(feedbackComment.toJson()),
    }).then((response) => {
      const feedbackCommentJson = camelCase(response.data.feedback_comment);
      feedbackComment.id = feedbackCommentJson.id;
      feedbackComment.persisted = true;
      feedbackComment.persistAttachments();
    })
      .catch((error) => {
        console.log(error);
      });
  }

  updateBackend(feedbackComment) {
    axios.patch(`/feedback_comments/${feedbackComment.id}.json`, {
      feedback_comment: snakeCase(feedbackComment.serialize()),
    }).then((response) => {
      // const json = camelCase(JSON.parse(response.data.feedback_comment), true);
      // feedbackComment.updateFromJson(json);
      // Success message
    }).catch((errors) => {
      console.log(errors);
    });
  }


  destroyBackend(feedbackComment) {
    axios.delete(`/feedback_comments/${feedbackComment.id}.json`).then((response) => {
    }).catch((errors) => {
      console.log(errors);
    });
  }
  // end BACKEND CONNECTIONS
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
